import { Navigate } from 'react-router-dom'
import { getClientPublicEntryPath, hasTenantBound } from '@/config/tenant'
import { useUser } from '@/contexts/UserContext'
import { isGuestSessionActive } from '@/utils/guestAuth'

/** Rotas desconhecidas: landing, portal da empresa ou menu. */
export function ClientFallbackRedirect() {
  const { user } = useUser()
  if (!hasTenantBound()) return <Navigate to="/" replace />
  return <Navigate to={user || isGuestSessionActive() ? '/menu' : getClientPublicEntryPath()} replace />
}
